import { render, staticRenderFns } from "./HlOnboardingRejectedPage.vue?vue&type=template&id=b42e1b64&scoped=true&"
import script from "./HlOnboardingRejectedPage.vue?vue&type=script&lang=ts&"
export * from "./HlOnboardingRejectedPage.vue?vue&type=script&lang=ts&"
import style0 from "./HlOnboardingRejectedPage.vue?vue&type=style&index=0&id=b42e1b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42e1b64",
  null
  
)

export default component.exports